import { Component, OnInit } from '@angular/core';
import { MarginReport, TokenAnalyticsService } from '../../../services/token-analytics.service';

/**
 * Deckungsbeitrag: was Credits einbringen gegen was die Modellaufrufe kosten.
 *
 * Erlös aus `credit_activity_events`, Kosten aus `ai_usage_log` (stündlicher
 * LangSmith-Import, al-tutor migration 186), verknüpft über usage_turn_id.
 * Plattformzahlen, deshalb auf der super_admin-Seite Token-Analytics und nicht
 * auf der Kundenseite „Credit-Verbrauch".
 *
 * Zielmarke 80 % gesamt. Hintergrundarbeit (Analytics, Lernerprofil, …) hat
 * keinen eigenen Preis und wird über die Marge der aktiven Aktionen getragen
 * (Migration 057) — deshalb steht ihr Anteil als eigene Kachel da.
 */
@Component({
  selector: 'app-margin-report',
  templateUrl: './margin-report.component.html',
  styleUrl: './margin-report.component.scss',
})
export class MarginReportComponent implements OnInit {
  readonly dayPresets = [7, 30, 90];
  days = 30;
  report: MarginReport | null = null;
  isLoading = false;
  loadFailed = false;
  importing = false;
  importedRuns: number | null = null;

  readonly euro = (v: number): string =>
    (v ?? 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 });
  readonly pct = (v: number): string =>
    `${(Math.round((v ?? 0) * 10) / 10).toLocaleString('de-DE')} %`;

  constructor(private tokenAnalytics: TokenAnalyticsService) {}

  ngOnInit(): void {
    this.load();
  }

  setDays(days: number | undefined): void {
    if (!days || days === this.days) return;
    this.days = days;
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.loadFailed = false;
    this.tokenAnalytics.getMargin(this.days).subscribe({
      next: (r) => {
        this.report = r;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.loadFailed = true;
      },
    });
  }

  importNow(): void {
    this.importing = true;
    this.tokenAnalytics.importMarginCosts().subscribe({
      next: (r) => {
        this.importedRuns = r.imported;
        this.importing = false;
        this.load();
      },
      error: () => {
        this.importing = false;
      },
    });
  }

  /** Farbe traegt die Aussage: unter 70 % rot, bis 80 % gelb, ab 80 % gruen.
   *  Ohne Erloes (reine Kosten) gibt es keine Marge — dann neutral. */
  level(margin: number | null): 'ok' | 'warn' | 'crit' | 'none' {
    if (margin === null || margin === undefined) return 'none';
    if (margin < 70) return 'crit';
    if (margin < 80) return 'warn';
    return 'ok';
  }

  trackByKey(_: number, row: { activity?: string; client_id?: string; source?: string }): string {
    return row.activity || row.client_id || row.source || '';
  }
}
